import { createResource, type RouteResource } from 'react-resource-router';

import type { GroupPolicy } from '@atlassian/aiops-group-common';
import { assert, AssertionError } from '@atlassian/eoc-common';

import { getTeamGroupPolicy } from '../endpoints';

export const teamGroupPolicyResource: RouteResource<GroupPolicy> = createResource({
	type: 'teamGroupPolicyResource',
	getKey: (routerContext) => `teamGroupPolicyResource#${routerContext.match.params.teamId}`,
	getData: async (routerContext) => {
		const teamId = routerContext.match.params?.teamId;

		assert(
			!!teamId,
			new AssertionError(
				'teamGroupPolicyResource',
				'teamId should be set to fetch team group policy',
			),
		);

		return getTeamGroupPolicy(teamId);
	},
	isBrowserOnly: true,
});
